import styled from "styled-components";

export const DocumentsContainer = styled.div`
  padding: 1.3rem 1.3rem 1.3rem 4rem;
`;

export const DocumentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

export const ContactContainer = styled.div`
  padding-left: 5.1rem;
`;

export const DocumentTitle = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 1rem 0;
`;

export const Title = styled.h2`
  font-family: "Lato";
  font-style: normal;
  font-size: 18px;
  line-height: 16px;
  font-weight: bold;
  color: #1bace4;
  text-transform: initial;
  margin: 0 0 0 0.3rem;
`;

export const DocumentInfo = styled.div`
  display: grid;
  grid-template-columns: 25.3rem 14.2rem 0rem;
  gap: 1.25rem;
  margin: 0;
`;

export const DocCreationDate = styled.span`
  position: relative;
  font-size: 14px;
  line-height: 16px;
  color: black;
  margin: 0;
`;

export const DocumentName = styled.a`
  position: relative;
  font-size: 14px;
  line-height: 16px;
  color: #1bace4 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none !important;
  cursor: pointer;
  text-transform: initial;
  margin: 0;
`;

export const ContactInfo = styled.div`
  display: grid;
  grid-template-columns: 11.3rem 12.8rem 14.4rem 0rem;
  gap: 1.25rem;
  color: black;
`;

export const ContactName = styled.p`
  position: relative;
  font-size: 14px;
  line-height: 16px;
  color: black;
  text-transform: initial;
  margin: 0;
`;

export const Name = styled.span`
  margin: 0 0 0 0.5rem;
`;

export const ContactPhone = styled.span`
  position: relative;
  font-size: 14px;
  line-height: 16px;
  color: black;
  margin: 0;
`;

export const ContactEmail = styled.span`
  position: relative;
  font-size: 14px;
  line-height: 16px;
  color: black;
  text-transform: lowercase;
  margin: 0;
`;

export const DocumentRow = styled.div`
  padding-left: 4.4rem;
  margin-bottom: 1rem;
`;

export const FileInputContainer = styled.div`
  position: relative;
`;

export const FileName = styled.p`
  line-height: 1;
  color: #32a728;
  position: absolute;
  top: -30px;
  margin: 0;
  font-family: "Lato";
  font-size: 14px;
`;

export const AddMoreDocumentTitle = styled.span`
  color: #ff5200;
  font-size: 16px;
`;

export const EmptyDocumentsMessage = styled.p`
  text-align: center;
  font-size: 16px;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
`;

export const AddDocumentForm = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 1rem;
  margin: 1.75rem 0 0 0;
  align-items: end;
`;

export const FileInput = styled.input`
  width: 0;
  visibility: hidden;
  height: 0;
`;

export const FileInputLabel = styled.label`
  background: #cccccc;
  border: 2px solid #1bace4;
  border-radius: 4px;
  padding: 10px 16px;
  width: auto;
  color: #1bace4;
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  cursor: pointer;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
